enum PixelStatus {
  Firing = 'Firing',
  NotFiring = 'Not Firing',
}

export default PixelStatus;
